export default {"src":"/_next/static/media/pool.1ea0257e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};